// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__1M_Fl","header":"MessagesList_header__2Ng8h","chat":"MessagesList_chat__1ds1A"};